import project1 from '../images/projectImages/jswithcss/ecommerce.png'
import project2 from '../images/projectImages/jswithcss/mediaplayer.png'
import project3 from '../images/projectImages/jswithcss/landingpage.png'
import project4 from '../images/projectImages/jswithcss/hangman.png'
import project5 from '../images/projectImages/jswithcss/weatherApp.png'
import project6 from '../images/projectImages/jswithcss/cyberShield.png'


const jswithcsslist = [
{
    id: '1',
    projectImage: project1,
    title: 'shop ease',
    description: "An ecommerce web app for buying items",
    liveDemoLink: "https://jojo588.github.io/Shop-Ease/",
    sourceCode: "https://github.com/Jojo588/Shop-Ease.git"

  },
  {
    id: '2',
    projectImage: project2,
    title: 'media player',
    description: "Online media player that allows users to play online media",
    liveDemoLink: "https://jojo588.github.io/Media-Player/",
    sourceCode: "https://github.com/Jojo588/Media-Player.git"

  },
    {
    id: '3',
    projectImage: project3,
    title: 'tech flow',
    description: "A landing page for a tech company",
    liveDemoLink: "https://jojo588.github.io/Tech_Flow-Landing-Page/",
    sourceCode: "https://github.com/Jojo588/Tech_Flow-Landing-Page.git"

  },
    {
    id: '4',
    projectImage: project4,
    title: 'hangman',
    description: "This is an online hangman game to entertain users",
    liveDemoLink: "https://jojo588.github.io/Hangman-Game/",
    sourceCode: "https://github.com/Jojo588/Hangman-Game.git"

  },
  {
    id: '5',
    projectImage: project5,
    title: 'weather app',
    description: "This is a dashboard that displays weather details for searched cities",
    liveDemoLink: "https://weather-app-seven-delta-58.vercel.app/",
    sourceCode: "https://github.com/Jojo588/weatherApp.git"

  },
  {
    id: '6',
    projectImage: project6,
    title: 'cyberShield',
    description: "This is a fictional tech landing page for a cybersecurity company",
    liveDemoLink: "https://tech-landing-page-pearl.vercel.app/",
    sourceCode: "https://github.com/Jojo588/techLandingPage.git"

  },

  ];
export default jswithcsslist;
